import { FC } from "react";
import { HorizontalStack } from "../../Stack";
import { TextForPageHeaders } from "../../Text";
import { IconButton, mergeStyles, Modal } from "@fluentui/react";
import { colorPallete } from "../../../assets/color";
import "./index.css";


export const FormModal: FC<any> = (props) => {
  const { children, disableScroll, ...rest } = props;

  const modalStyles = {
    root: {
      boxShadow: "0px 0px 60px 0px rgba(0, 0, 0, 0.40)",
      overflowY: "hidden",
    },
    scrollableContent: {
      maxHeight: "90vh",
      overflowY: disableScroll ? "visible" : "auto",
    },
    main: {
      width: props.width,
      height: props.height,
      borderRadius: "8px",
    },
  };

  const headerStackStyles = {
    root: {
      backgroundColor: colorPallete.btBlue,
      padding: props.HeaderPadding || "12px 20px 0px 20px",
      color: colorPallete.white,
      // maxHeight: "333px"
    },
  };

  const contentStyles = {
    // overflowY: "hidden" as const,
    // maxHeight: "95vh",
  };

  return (
    <Modal
      {...rest}
      styles={modalStyles}
      isOpen={props.isModalOpen}
      onDismiss={props.hideModal}
      className={disableScroll ? mergeStyles({ overflowY: "hidden" }) : ""}
      isBlocking={true}
      responsiveMode
    >
      <HorizontalStack
        styles={headerStackStyles}
        horizontalAlign="space-between"
        style={{
          background: props?.TitleBackgroundColor,
          color: props?.TitleColor,
        }}
      >
        {props.title && <TextForPageHeaders>{props.title}</TextForPageHeaders>}
        {props.cancelButton && (
          <IconButton
            iconProps={{ iconName: props.cancelIconName || "Cancel" }}
            onClick={props?.customCancel ? props.customCancel : props.hideModal}
            style={{
              color: props.title ? props?.TitleColor : colorPallete.black1,
              position: "relative",
              right: "-10px",
              padding: "12px 0px 0 0px",
              width: "auto",
              height: "auto",
              backgroundColor: "inherit",
            }}
          />
        )}
      </HorizontalStack>
      {disableScroll ? (
        <div style={contentStyles}>
          {children}
        </div>
      ) : (
        <> {children} </>
      )}
    </Modal>
  );
};
